import { getAmplitudeClient } from 'src/lib/tracking';

/**
 * Clears the identity Amplitude holds in memory (userId/deviceId) on logout.
 *
 * This must run *before* we clear localStorage: otherwise the in-memory client
 * (and its engagement plugin) re-persists the user's identity — e.g. the
 * email-keyed `amplitude.engagement.eus.*.user_id:<email>` entry — right after
 * the clear. Resetting first means nothing recreates those entries.
 */
export const resetAmplitude = () => {
  getAmplitudeClient()?.reset();
};
